import { useSelector } from "react-redux";
import { selectCurrentDataSetId } from "../../../../../store/selectors/metaDataSelectors";
import { DataSetIds } from "../../../../../utilities/DimensionNames";
import type { CustomMeasureReturnType } from "../hooks/useCustomMeasure";
import SubgroupSelect from "../subgroup/SubgroupSelect";

interface Props {
  state: CustomMeasureReturnType;
}

const SubgroupField = ({ state }: Props) => {
  const dataSetId = useSelector(selectCurrentDataSetId);

  if (dataSetId !== DataSetIds.GeneralAndMemo) {
    return null;
  }

  return (
    <SubgroupSelect
      group={state.group}
      subgroupId={state.subgroupId}
      onChange={(subgroupId) => state.actions.update({ subgroupId })}
    />
  );
};

export default SubgroupField;
